import UserFriendsIcon from 'src/app/assets/icons/ico-user-friends.svg'
import { useGetTotalBets } from 'src/store/social'

export function TotalBets() {
  const totalBets = useGetTotalBets()

  return (
    <div className="players-stats__total-bets">
      <span className="value">
        <UserFriendsIcon />
        {totalBets}
      </span>
    </div>
  )
}
